export default String.raw`
.after-adding-to-popup {
    width: 768px;
    max-width: 768px;
    min-height: 320px;
    max-height: 872px;

    .dialog {
        &__header {
            gap: 16px;

            &-title {
                margin-right: auto;
            }

            svg {
                flex-shrink: 0;
            }
        }

        &__content {
            padding: 24px 32px 0 32px;

            .products__list {
                display: flex;
                box-sizing: border-box;
                flex-direction: column;
                width: 100%;
                min-height: 90px;
                max-height: 272px;
                align-items: flex-start;
                gap: 24px;
                overflow-y: auto;
                flex: 1;
                padding-right: 10px;

                &-item {
                    display: flex;
                    gap: 24px;
                    align-items: flex-start;
                    justify-content: center;
                    flex-direction: row;
                    width: 100%;
                }

                .product {
                    &__image {
                        max-width: 100%;
                        height: auto;
                        max-height: 100%;
                        object-fit: contain;
                        border-radius: 4px;

                        &-wrapper {
                            width: 80px;
                            height: 80px;
                            aspect-ratio: 1;
                            border-radius: 4px;
                            display: flex;
                            justify-content: center;
                        }
                    }

                    &__price {
                        @include body-2-regular;
                        display: flex;
                        flex-direction: column;
                        margin-left: auto;
                        align-self: flex-start;
                        white-space: nowrap;

                        .value {
                            @include h4-headline;
                        }

                        .currency {
                            @include body-2-regular;
                            margin-left: 4px;
                        }
                    }

                    &__details {
                        display: flex;
                        flex: 1 1 auto;
                        flex-direction: column;
                        gap: 8px;
                        height: 100%;
                    }

                    &__attributes {
                        @include body-1-regular;
                        display: flex;
                        gap: 8px;
                        flex: 1 1 auto;
                        flex-wrap: wrap;

                        .key {
                            white-space: no-wrap;
                        }

                        .value {
                            @include body-1-semi-bold;
                        }

                        &--quantity {
                            white-space: nowrap;
                        }
                    }
                    
                    &__name {
                        @include body-1-medium;
                        flex: 0 0 auto;
                        word-break: break-word;
                    }
                }
            }

            .ai-recommended {
                width: 100%;
            }
        }

        &__actions {
            width: 100%;
            padding: 16px 32px 32px 32px;
            justify-content: space-between;
        }
    }
}
`